import { Button, Modal, Result } from 'antd';
import React from 'react';

interface ErrorModalProps {
  resetError: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ resetError }) => (
  <Modal footer={null} closable={false} open>
    <Result
      status="500"
      title="Oops"
      subTitle="Sorry, something went wrong."
      extra={<Button type="primary" onClick={resetError}>Try again</Button>}
    />
  </Modal>
)

export default ErrorModal;

